import type { CaseDefinition, CaseId, LoadTableId } from "../domain/types/index.js";
import { LOAD_TABLES } from "./loads.js";

export type CaseSpec = {
  name: string;
  size: CaseDefinition["size"];
  required: number;
  deadline: number;
  flavor: string;
  loadTable: LoadTableId;
  isBoss?: boolean;
  grantsOrganization?: boolean;
};

export function defineCases(specs: Record<CaseId, CaseSpec>): Record<CaseId, CaseDefinition> {
  return Object.fromEntries(
    Object.entries(specs).map(([id, spec]) => [
      id,
      {
        id,
        name: spec.name,
        size: spec.size,
        required: spec.required,
        deadline: spec.deadline,
        flavor: spec.flavor,
        loads: LOAD_TABLES[spec.loadTable],
        ...(spec.isBoss ? { isBoss: true } : {}),
        ...(spec.size === "large" || spec.grantsOrganization ? { grantsOrganization: true } : {}),
      },
    ]),
  ) as Record<CaseId, CaseDefinition>;
}
